{
  "main": {
    "title": "Repertorio piloti",
    "nazaj": "Indietro"
  },
  "navs": {
    "vnos": "Inserimento",
    "seznam": "Elenco"
  },
  "search": {
    "placeholder": "Cerca per codice, nome o cognome"
  },
  "table": {
    "sifra": "Codice",
    "ime": "Nome",
    "priimek": "Cognome",
    "podrobno": "Dettagli"
  },
  "modal": {
    "sifra": "Codice:",
    "naslov": "Indirizzo:",
    "posta": "CAP:",
    "kraj": "Città:",
    "email": "E-mail:",
    "telefon": "Telefono:",
    "klub": "Club:",
    "naletJ": "Ore aliante:",
    "naletM": "Ore motore:",
    "opomba": "Nota:",
    "instruktor": "Istruttore:",
    "instruktorJ": "Istruttore di aliante:",
    "instruktorUL": "Istruttore di ultralight:",
    "vlecniR": "Rating traino",
    "jadralniP": "Pilota di aliante?",
    "motorniP": "Pilota di aereo a motore?",
    "ultraP": "Pilota di aereo ultralight?"
  },
  "vabilo": {
    "title": "Scansiona codice QR",
    "opomba": "L’utente ha già accesso all’applicazione!"
  },
  "labels": {
    "ime": "Nome",
    "priimek": "Cognome",
    "naslov": "Indirizzo",
    "posta": "CAP",
    "kraj": "Città",
    "email": "E-mail",
    "telefon": "Telefono",
    "klub": "Club",
    "klubI": "Seleziona club:",
    "naletJ": "Ore aliante:",
    "naletM": "Ore motore:",
    "opomba": "Nota:",
    "instruktor": "Istruttore:",
    "instruktorJ": "Istruttore di aliante:",
    "instruktorUL":"Istruttore ultralight:",
    "vlecniR": "Rating traino:",
    "jadralniP": "Pilota di aereo da vela",
    "motorniP": "Pilota di aereo a motore",
    "ultraP": "Pilota di ultraleggero",
    "licenca": "Licenza:"
  },
  "buttons": {
    "csv": "Esporta in CSV",
    "povabi": "Invita",
    "deli": "Condividi",
    "uredi": "Modifica",
    "posodobi": "Aggiorna dati",
    "izbrisi": "Elimina",
    "brisiIzbiro": "Cancella selezione"
  }
}